<template>
  <div class="mobile-width">
    <Header :balai="balai" />
    <div v-if="!loading_i">
      <div class="bwsTitle mobile-top d-flex justify-content-between" :class="{ 'darkMode': isDarkMode }">
        <div style="text-transform: uppercase;">
          {{ balai_name }}
        </div>

      </div>
      <Map :balai="balai" :zoom="zoom" :center="center" />

      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Public/Header";
import logoPU from "@/assets/logo_pupr.svg";
import Map from "@/components/Map/Map.vue";
import axios from "axios";

export default {
  components: {
    Header,
    Map,
  },
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    },
  },
  data() {
    return {
      stations: [],
      isPaused: false,
      text_duration: null,
      text_repeat: null,
      logoPU,
      ava_width: null,
      ava_height: null,
      balai: null,
      loading_i: true,
      balai_name: "",
      custom_duration: null,
      showCarousel: true,
      currentDateTime: 12,
      zoom: 4,
      center: undefined,
    };
  },
  methods: {
    async balaiNonAuth() {
      // Get screen dimensions
      this.ava_width = screen.availWidth;
      this.ava_height = screen.availHeight;

      // Retrieve user info from localStorage
      let user = localStorage.getItem("user-info");
      let parsedUser = user && typeof user === "string" ? JSON.parse(user) : null;

      try {
        if (!parsedUser) {
          // Non-authenticated user (no user info in localStorage)
          this.balai = this.$fixedBalai;

          const response = await axios.get(`${this.$baseURL}/balai/non-auth/${this.balai}`);
          this.setBalaiDetails(response.data[0]);
        } else {
          // Authenticated user
          this.role = parsedUser.profile.role;
          this.user_id = parsedUser.profile.user.id;
          this.balai = parsedUser.profile.balai.id;
          this.token = parsedUser.token;

          const response = await axios.get(`${this.$baseURL}/balai/${this.balai}`, {
            headers: {
              Authorization: `Token ${this.token}`,
            },
          });
          this.setBalaiDetails(response.data);
        }
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          this.logoutUser();
        } else {
          console.error('Error msg: ', error);
        }
      }
    },

    setBalaiDetails(balaiData) {
      this.detBalai = balaiData;
      this.text_duration = balaiData.text_duration;
      this.text_repeat = balaiData.text_repeat;
      this.zoom = balaiData.map_zoom;
      this.center = [balaiData.latitude, balaiData.longitude];
    }


  },
  async created() {
    this.loading_i = false;
    this.balai_name = document.title;
    this.extractUserInfo();

    this.balaiNonAuth()
  },


};
</script>

<style scoped src="@/assets/css/flex14.css"></style>

<style>
.mobile-width {
  max-width: 92%;
  margin-left: 80px;
}

.mobile-top {
  margin: 0px 0px 5px;
}

@media (max-width: 768px) {
  .mobile-width {
    max-width: 97%;
    margin: auto;
  }

  .mobile-top {
    margin-top: 5px;
  }
}

.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  /* Center vertically within viewport */
}

.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-container {
  margin-right: 20px;
}
</style>